

exports.__esModule = true;

var _index = require('squid/index');

require('xo-ui-components/src/floating-label/directive');

require('./styles');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('$xoGenderType', {
    tag: 'xo-gender-type',
    template: _template2['default'],

    props: {
        user: {
            type: 'var'
        }
    }
});


_index.$Component;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-form-components/src/gender-type/directive.js
// module id = ./components/xo-form-components/src/gender-type/directive.js
// module chunks = 1